import { useFilterEmployeeBranchContext } from "./filter-employee-branch.context";

export function FilterEmployeeBranch() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterEmployeeBranchContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}